import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo, useState } from "react";
import {
  getLocalSettingsMasterConfigList,
  updateLocalSettingsMasterConfigToggle,
  updateLocalSettingsMasterConfigToggleSuccess,
} from "../../../../store/generalSettings/action";
import { Card, CardBody, CardHeader, Col, Input, Label, Row } from "reactstrap";
import { isEmpty } from "lodash";
import LoadingSpinner from "../../../../Components/Common/Spinner";
import TableContainer from "../../../../Components/Common/TableContainer";
import "./generalSettings.css";
import { toast } from "react-toastify";
export default function LocalSettings() {
  const dispatch = useDispatch();
  //local state
  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "Id",
    "ConfigCompany_Id",
    "ConfigCompany_Value",
    "ConfigUser_Value",
  ]);
  const [searchResults, setSearchResults] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  // state from redux
  const {
    localSettingsMasterConfigListAPI,
    localSettingsMasterConfigListLoading,
  } = useSelector((state) => ({
    localSettingsMasterConfigListAPI:
      state.GeneralSettings.localSettingsMasterConfigList
        ?.masterconfigitem_list,
    localSettingsMasterConfigListLoading:
      state.GeneralSettings.localSettingsMasterConfigListLoading,
  }));

  useEffect(() => {
    dispatch(getLocalSettingsMasterConfigList());
  }, []);
  const [itemToEdit, setItemToEdit] = useState({});
  const columns = useMemo(
    () => [
      {
        // job id  with beginning #Job_Id
        Header: "Company Id",
        accessor: "ConfigCompany_Id",
        filterable: false,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                <span className={"like-href"}>
                  {" "}
                  #{card.row.original?.ConfigCompany_Id}
                </span>
              </div>
            </div>
          </>
        ),
      },
      {
        // job id  with beginning #Job_Id
        Header: "Company Value",
        accessor: "ConfigCompany_Value",
        filterable: false,
        Cell: (card) => (
          <>
            <div>
              {card.row.original?.ConfigCompany_Id ===
              itemToEdit.ConfigCompany_Id ? (
                <div>
                  <Input
                    autoFocus={true}
                    type="text"
                    className="form-control"
                    placeholder="Enter Company Value"
                    value={itemToEdit.ConfigCompany_Value}
                    onChange={(e) => {
                      setItemToEdit({
                        ...itemToEdit,
                        ConfigCompany_Value: e.target.value,
                      });
                    }}
                    onBlur={(e) => {
                      handleUpdateUserOverride(
                        "companyValue",
                        card.row.original,
                        e.target.value
                      );
                    }}
                    // on press enter only
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleUpdateUserOverride(
                          "companyValue",
                          card.row.original,
                          e.target.value
                        );
                      }
                    }}
                  />
                </div>
              ) : (
                <div>
                  {card.row.original?.ConfigCompany_Value}
                  {/*- icon edit */}
                  <i
                    title={"Click to edit"}
                    className="ri-edit-line edit-icon cursor-pointer text-warning ms-2"
                    onClick={() => setItemToEdit(card.row.original)}
                  ></i>
                </div>
              )}
            </div>
          </>
        ),
      },
      {
        // job id  with beginning #Job_Id
        Header: "User Override",
        accessor: "ConfigCompany_FlagAllowUserOverride",
        filterable: false,
        Cell: (card) => (
          <>
            <label className="switch">
              <input
                type="checkbox"
                checked={
                  card.row.original?.ConfigCompany_FlagAllowUserOverride === "1"
                }
                onChange={() => {
                  handleUpdateUserOverride("toggle", card.row.original);
                }}
              />
              <span className="slider round"></span>
            </label>
          </>
        ),
      },
      {
        Header: "Item Id",
        accessor: "MasterConfigItem_Id",
        //accessor status is  joblist.JobStatus_Id jobStatus.ID jobStatus.Name
        Cell: (card) => {
          return (
            <div>
              <span className={""}>
                {card.row.original?.MasterConfigItem_Id}{" "}
              </span>
            </div>
          );
        },
        filterable: false,
      },
      {
        Header: "Item Title",
        accessor: "MasterConfigItem_Title",
        //accessor status is  joblist.JobStatus_Id jobStatus.ID jobStatus.Name
        Cell: (card) => {
          return (
            <div>
              <span className={""}>
                {card.row.original?.MasterConfigItem_Title}{" "}
              </span>
            </div>
          );
        },
        filterable: false,
      },
    ],
    [searchResults, itemToEdit]
  );

  useEffect(() => {
    let filteredCustomerList = localSettingsMasterConfigListAPI;
    const timer = setTimeout(() => {
      filteredCustomerList = filteredCustomerList?.filter((item) => {
        return allowedSearchFilters.some((key) => {
          return (
            item[key] &&
            item[key]
              .toString()
              .toLowerCase()
              .includes(searchQuery?.toLowerCase())
          );
        });
      });

      setSearchResults(filteredCustomerList);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchQuery, localSettingsMasterConfigListAPI]);
  const handleUpdateUserOverride = (type, item, change) => {
    if (type === "toggle") {
      const dateUpdate = [
        {
          MasterConfigItem_Id: item?.MasterConfigItem_Id,
          ConfigCompany_FlagAllowUserOverride:
            item?.ConfigCompany_FlagAllowUserOverride === "1" ? "0" : "1",
          ConfigCompany_Value: item?.ConfigCompany_Value,
        },
      ];
      dispatch(updateLocalSettingsMasterConfigToggle(dateUpdate));
    }
    if (type === "companyValue") {
      const dateUpdate = [
        {
          MasterConfigItem_Id: item?.MasterConfigItem_Id,
          ConfigCompany_FlagAllowUserOverride:
            item?.ConfigCompany_FlagAllowUserOverride,
          ConfigCompany_Value: change,
        },
      ];
      dispatch(updateLocalSettingsMasterConfigToggle(dateUpdate));
    }
  };

  const { updateLocalSettingsMasterConfigToggleSuccessAPI } = useSelector(
    (state) => ({
      updateLocalSettingsMasterConfigToggleSuccessAPI:
        state.GeneralSettings.updateLocalSettingsMasterConfigToggleSuccess,
    })
  );

  useEffect(() => {
    if (isEmpty(updateLocalSettingsMasterConfigToggleSuccessAPI)) return;
    if (updateLocalSettingsMasterConfigToggleSuccessAPI.status === 200) {
      dispatch(getLocalSettingsMasterConfigList());
      toast.success(updateLocalSettingsMasterConfigToggleSuccessAPI.message);
      setItemToEdit([]);
    } else {
      toast.error(updateLocalSettingsMasterConfigToggleSuccessAPI.message);
    }
    dispatch(updateLocalSettingsMasterConfigToggleSuccess([]));
  }, [updateLocalSettingsMasterConfigToggleSuccessAPI]);

  return (
    <div>
      <Row className={"mt-2"}>
        <Col lg={12}>
          <Card id="customersList">
            <CardHeader className="border-0 ">
              <Row className="g-4 align-items-center">
                <Col sm={3}>
                  <div className="search-box">
                    <Input
                      // create search with jobs List Data
                      type="search"
                      className="form-control search"
                      placeholder="Search for..."
                      onChange={(e) => setSearchQuery(e.target.value)}
                      value={searchQuery}
                    />
                    <i className="ri-search-line search-icon"></i>
                  </div>
                </Col>
                <div className="col-sm-auto ms-auto">
                  {/*<div className="hstack gap-2">*/}
                  {/*  <a*/}
                  {/*    href={"#AddNewLicense"}*/}
                  {/*    type="button"*/}
                  {/*    className="btn btn-success add-btn btn-info-add-jobs"*/}
                  {/*    id="create-btn"*/}
                  {/*  >*/}
                  {/*    <i className="ri-add-line align-bottom me-1"></i>*/}
                  {/*    Add New License*/}
                  {/*  </a>*/}
                  {/*</div>*/}
                </div>
              </Row>
            </CardHeader>
            <CardBody className="pt-0">
              <div>
                {localSettingsMasterConfigListLoading ? (
                  <LoadingSpinner />
                ) : (
                  <div>
                    {!isEmpty(searchResults) ? (
                      <TableContainer
                        columns={columns}
                        data={searchResults || []}
                        isGlobalFilter={false}
                        isAddUserList={false}
                        customPageSize={10}
                        className="custom-header-css"
                        divClass="table-responsive table-card mb-0"
                        tableClass="align-middle table-nowrap"
                        theadClass="text-muted"
                        // handleLeadClick={handleLeadClicks}
                        isLeadsFilter={false}
                      />
                    ) : (
                      <div>You currently have no settings available</div>
                    )}
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
